class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = true;

    if (!this.detailsContainer) return;

    if (this.summaryToggle) {
      this.summaryIsEmpty = (this.summaryToggle.textContent || '').trim().length === 0;

      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
      });

      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    }

    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    const hasThemeMqlSmall = !!(window.theme && theme.config && theme.config.mqlSmall);

    if (!hasThemeMqlSmall || this.summaryIsEmpty || !this.summaryToggle) {
      this.detailsContainer.setAttribute('open', true);
      if (this.summaryIsEmpty) this.detailsContainer.setAttribute('empty', true);
    } else {
      if (this.dataset.open == undefined) this.detailsContainer.removeAttribute('open');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (!details) return;
    details.hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    if (this.detailsContainer) this.detailsContainer.setAttribute('open', true);
  }

  close() {
    const hasThemeMqlSmall = !!(window.theme && theme.config && theme.config.mqlSmall);
    if (hasThemeMqlSmall && !this.summaryIsEmpty && this.detailsContainer) this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('footer-accordion', FooterAccordion);
